import { TRIGGERS } from '@/api/global';
import Modal from '@/components/structure/Modal';
import { useLayoutContext } from '@/context/LayoutContext';
import React, { Fragment, useState } from 'react';
import styles from './styles.module.css';
import { useTranslations } from 'next-intl';

import PageCardHeader from '@/components/general/PageCard/PageCardHeader';
import MainIcons from '@/icons/main';
import { avatarBg, lightBg, lightBgIcon } from '@/functions/formats';
import PaymentModal from './PaymentModal';
import LoginModal from './LoginModal';
import SubUserModal from './SubUserModal';
import AddSubuserModal from './AddSubuserModal';
import EditPlateModal from './EditPlateModal';
import ConfirmModal from '@/components/common/ConfirmModal';
import BasketModal from './BasketModal';
import ServiceReserveModal from './ServiceReserveModal';
import AddressModal from './AddressModal';

export default function ModalsContainer() {
  const {
    trigger,
    setTrigger,
    singleItem,
    setSingleItem,
    confirmation,
    setConfirmation,
    setEditInfo,
    editInfo,
  } = useLayoutContext();
  const tCompare = useTranslations('ComparePage');
  const { totalCount, paymentInfo } = useLayoutContext();
  const tCommon = useTranslations('common');
  const [activeLogin, setActiveLogin] = useState(1);

  return (
    <>
      {trigger == TRIGGERS.LOGIN_MODAL && (
        <Modal
          handleShowModal={() => {
            setTrigger(TRIGGERS.EMPTY);
            setActiveLogin(1);
            if (activeLogin == 3) {
              window.location.reload();
            }
          }}
          title={activeLogin != 3 ? 'ورود به کارا' : null}
          modalKey={TRIGGERS.LOGIN_MODAL}
          extraContentStyle={`${styles.loginContent}`}
        >
          <LoginModal
            modalKey={TRIGGERS.LOGIN_MODAL}
            active={activeLogin}
            setActive={setActiveLogin}
          />
        </Modal>
      )}
      {trigger == TRIGGERS.PAYMENT_MODAL && (
        <Modal
          handleShowModal={() => {
            setTrigger(TRIGGERS.EMPTY);
          }}
          title={
            <PageCardHeader
              title={paymentInfo?.type == 'inq' ? 'پرداخت هزینهٔ استعلام' : 'پرداخت خلافی'}
              icon={<MainIcons.searchIcon fill="var(--paper)" />}
              backgroundIcon={avatarBg(0)}
              iconClass={`${styles.paymentIcon}`}
              text="روش پرداخت را انتخاب کنید"
              textClass={`${styles.paymentText}`}
            />
          }
          extraContentStyle={styles.paymentContent}
        >
          <PaymentModal />
        </Modal>
      )}
      {trigger == TRIGGERS.SUBUSER_MODAL && (
        <Modal
          handleShowModal={() => {
            setTrigger(TRIGGERS.EMPTY);
          }}
          title={'لیست کاربران'}
          text="کاربران زیرمجموعهٔ این حساب را مدیریت کنید"
          extraContentStyle={styles.subUserContent}
        >
          <SubUserModal />
        </Modal>
      )}
      {trigger == TRIGGERS.ADD_SUBUSER && (
        <Modal
          handleShowModal={() => {
            setTrigger(TRIGGERS.EMPTY);
          }}
          title="اطلاعات کاربر"
          text="برای افزودن کاربر به لیست، لطفا اطلاعات شخص را وارد نمایید"
          extraContentStyle={styles.subUserContent}
          modalKey={TRIGGERS.ADD_SUBUSER}
        >
          <AddSubuserModal modalKey={TRIGGERS.ADD_SUBUSER} />
        </Modal>
      )}
      {trigger == TRIGGERS.EDIT_PLATE_MODAL && (
        <Modal
          handleShowModal={() => {
            setTrigger(TRIGGERS.EMPTY);
          }}
          title="ویرایش  پلاک کاربر "
          text="برای ویرایش پلاک کاربر، لطفا اطلاعات زیر را وارد نمایید."
          extraContentStyle={styles.plateModalContent}
          modalKey={TRIGGERS.EDIT_PLATE_MODAL}
        >
          <EditPlateModal modalKey={TRIGGERS.EDIT_PLATE_MODAL} />
        </Modal>
      )}
      {confirmation && (
        <Modal
          handleShowModal={() => {
            setConfirmation(null);
          }}
          title={confirmation?.title}
          extraContentStyle={styles.confirmationContent}
          extraHeaderStyle={styles.extraHeaderStyleConfirmation}
        >
          <ConfirmModal
            text={confirmation?.text}
            confirmText={confirmation?.confirmText}
            rejectText={confirmation?.rejectText}
            confirmFunction={() => {
              confirmation.confirmFunction();
              setConfirmation(null);
            }}
            rejectFunction={() => {
              confirmation.rejectFunction();
              setConfirmation(null);
            }}
          ></ConfirmModal>
        </Modal>
      )}
      {(trigger == TRIGGERS.BASKETMODAL || trigger == TRIGGERS.RERENDER_BASKETMODAL) && (
        <Modal
          handleShowModal={() => {
            setTrigger('');
          }}
          title={
            <div className={`${styles.cartTitlePart}`}>
              <MainIcons.basketIcon />
              <span>{tCommon('cart')}</span>
              <span className={`${styles.basketNumber}`}>{totalCount}</span>
            </div>
          }
          extraContentStyle={styles.basketModalContent}
          extraHeaderStyle={styles.cartExtraHeaderStyle}
          modalKey={TRIGGERS.BASKETMODAL}
          extrawrapperstyle={styles.basketModalExtrawrapperstyle}
        >
          <BasketModal />
        </Modal>
      )}
      {trigger == TRIGGERS.RESERVE_SERVICE && editInfo && (
        <Modal
          handleShowModal={() => {
            setTrigger(TRIGGERS.EMPTY);
            setEditInfo && setEditInfo(undefined);
          }}
          title={
            <PageCardHeader
              title={editInfo?.item?.title}
              backgroundIcon={avatarBg(0)}
              icon={<MainIcons.ServiceIcon fill="#fff" width="22px" height="22px" />}
              iconClass={styles.serviceIcon}
              text={editInfo?.level == 1 ? 'انتخاب روز و ساعت' : 'محل و پرداخت'}
            />
          }
          extraHeaderStyle={`${styles.serviceReserveModalHeader}`}
          extraContentStyle={styles.reserveModalContent}
          modalKey={TRIGGERS.EDIT_PLATE_MODAL}
        >
          <ServiceReserveModal />
        </Modal>
      )}
      {trigger == TRIGGERS.FORM_MODAL && (
        <Fragment>
          {singleItem?.name == 'address' && (
            <Modal
              handleShowModal={() => {
                setSingleItem(undefined);
                setTrigger(TRIGGERS.EMPTY);
              }}
              // title={singleItem?.type == 'add' ? tCommon('addAddress') : tCommon('editAddress')}
              title={
                <PageCardHeader
                  title={singleItem?.type == 'add' ? tCommon('addAddress') : tCommon('editAddress')}
                  backgroundIcon={lightBg(0)}
                  icon={<MainIcons.locationIcon fill={lightBgIcon(0)} width="22px" height="22px" />}
                  iconClass={styles.serviceIcon}
                  text={'اطلاعات آدرس تحویل سفارش را وارد کنید'}
                />
              }
              modalKey={TRIGGERS.ADDRESS_MODAL}
              extraContentStyle={`${styles.addressContent}`}
              // extraContentInsideClass={`${styles.picker_inside}`}
            >
              <AddressModal
                modalKey={TRIGGERS.ADDRESS_MODAL}
                data={singleItem?.data}
                setData={setSingleItem}
                type={singleItem?.type}
              />
            </Modal>
          )}
        </Fragment>
      )}
      {/* {trigger == TRIGGERS.COMPARE_MODAL && (
        <Modal
          handleShowModal={() => {
            setTrigger('');
          }}
          title={tCompare('head.button')}
          modalKey={TRIGGERS.COMPARE_MODAL}
          extraContentStyle={`${styles.picker}`}
          extraContentInsideClass={`${styles.picker_inside}`}
        >
          <CompareModal />
        </Modal>
      )}
      {(trigger == TRIGGERS.BASKETMODAL || trigger == TRIGGERS.RERENDER_BASKETMODAL) && (
        <Modal
          handleShowModal={() => {
            setTrigger('');
          }}
          title={
            <div className={`${styles.cartTitlePart}`}>
              <MainIcons.basketIcon />
              <span>{tCommon('cart')}</span>
              <span className={`${styles.basketNumber}`}>{totalCount}</span>
            </div>
          }
          extraContentStyle={styles.basketModalContent}
          extraHeaderStyle={styles.cartExtraHeaderStyle}
          modalKey={TRIGGERS.BASKETMODAL}
          extrawrapperstyle={styles.basketModalExtrawrapperstyle}
        >
          <BasketModal />
        </Modal>
      )}

      {trigger == TRIGGERS.OPEN_MODAL && (
        <Fragment>
          {singleItem?.name == 'order' && (
            <Modal
              handleShowModal={() => {
                setSingleItem(undefined);
                setTrigger('');
              }}
              title={<OrderDetailsTitle data={singleItem?.data} />}
              modalKey={TRIGGERS.ORDER_DETAILS}
              extraContentStyle={`${styles.orderDetailsContent}`}
              extraHeaderStyle={`${styles.orderExtraHeaderStyle}`}
            >
              <OrderDetails
                modalKey={TRIGGERS.ORDER_DETAILS}
                data={singleItem?.data}
              />
            </Modal>
          )}
        </Fragment>
      )}
      */}
    </>
  );
}
